import React, {Component} from 'react';
import {pageWithPrismic} from "../website-gridhaus/pageWithPrismic";
import {Date as PrismicDate, RichText} from "prismic-reactjs";
import {ENDPOINT, routes} from "../config";
import {Redirect} from "react-router-dom";
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles} from "../website-gridhaus/meta";
import {DefaultPlayer} from '@gridhaus/react-html5video';
import {fetchArticlesIfNeeded, openSubscribePopup} from "../redux/actions";
import moment from "moment";
import ArticleBody from "../parts/ArticleBody";
import {withStyles} from '@material-ui/core/styles';
import {getNavBarHeight, sidePaddingNormal, verticalPaddingNormal} from "../styles/layouts";
import SocialShare from "../parts/SocialShare";
import Navigator from "../parts/Navigator";
import Prismic from 'prismic-javascript';
import {standardContainer} from "../styles/mixins";
import Figure from "../parts/Figure";
import Section from "../parts/Section";
import Container from "../parts/Container";
import {store} from '../index';


const styles = (theme) => ({
  page: {
    paddingTop: '4em',
    [theme.breakpoints.up('md')]: {
      paddingTop: '12em',
    }
  },
  container: {
    ...standardContainer(theme),
  },
  header: {
    ...sidePaddingNormal(theme),
  },
  meta: {
    textAlign: 'center',
    maxWidth: theme.layout.contentMaxWidth,
    margin: '0 auto',
  },
  category: {
    color: theme.palette.primary.main,
    ...theme.typography.hg18bu(theme),
    marginBottom: theme.spacing.unit * 2,
  },
  title: {
    ...theme.typography.hg54r(theme),
    marginBottom: theme.spacing.unit * 2,
  },
  authorDate: {
    ...theme.typography.hg18bu(theme),
    marginBottom: theme.spacing.unit * 2,
  },
  separator: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  socialShare: {
    marginBottom: theme.spacing.unit * 4,
  },
  image: {
    maxWidth: '100%',
    marginBottom: theme.spacing.unit * 6,
  },
  body: {
    marginBottom: theme.spacing.unit * 4,
  },
  navigator: {
    padding: `${theme.spacing.unit * 10}px 0`,
  }
});


class ArticlePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      article: null,
      newerArticle: null,
      olderArticle: null,
      api: null,
    }
    this.articleRef = React.createRef();
  }

  componentDidMount() {
    // Retrieve the api object
    Prismic.api(ENDPOINT).then(api => {
      // Perform your query
      api.getByUID('article', this.props.match.params.uid).then(response => {
        if (response) {
          // Set the api and response as state variables
          this.setState({
            api: api,
          });
        }
      });
    });
    window.analytics.page("Blog", "Article");

    window.addEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const screenBottom = window.innerHeight + (document.scrollingElement || document.documentElement).scrollTop;
    const article = this.articleRef.current;
    const articleThreshold = article.offsetTop + article.clientHeight * 0.5;

    if (screenBottom > articleThreshold) {
      !window.suppressSubscribePopup && store.dispatch(openSubscribePopup());
    }
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  componentDidUpdate() {
    this.refreshToolbar();
  }

  refreshToolbar() {
    // Start an experiment if there is one
    const maybeCurrentExperiment = this.state.api && this.state.api.currentExperiment();
    if (maybeCurrentExperiment) {
      window.PrismicToolbar.startExperiment(maybeCurrentExperiment.googleId());
    }

    // Launch the prismic.io toolbar
    window.PrismicToolbar && window.PrismicToolbar.setup(ENDPOINT);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const uid = nextProps.match.params.uid;
    if (nextProps.articles) {
      const currentArticle = nextProps.articles.filter((article) => article.uid === uid)[0];
      if (!currentArticle) {
        return <Redirect to={routes.notFound}/>
      }

      const currIndex = nextProps.articles.indexOf(currentArticle);
      const olderArticle = (currIndex < nextProps.articles.length) ? nextProps.articles[currIndex + 1] : null;
      const newerArticle = (currIndex > 0) ? nextProps.articles[currIndex - 1] : null;

      return {
        article: currentArticle,
        newerArticle: newerArticle,
        olderArticle: olderArticle,
      };
    }
    return prevState;
  }

  render() {
    const {classes} = this.props;

    window.prerenderReady = false;
    if (this.state.article) {
      window.prerenderReady = true;
      const data = this.state.article.data;
      return (
        <div className={classes.page}>
          <Helmet>
            <title>{data.title}</title>
            {metaTitles(data.title)}
            {metaImages(data.image.url)}
            {metaDescriptions(data.description)}
          </Helmet>
          <article ref={this.articleRef}>
            <header className={classes.header}>
              <div className={classes.container}>
                <div className={classes.meta}>
                  <div className={classes.category}>{data.category}</div>
                  <div className={classes.title}>{data.title}</div>
                  <div className={classes.authorDate}>
                    <span className={classes.author}>
                      {`By ${data.author}`}
                    </span>
                    <span className={classes.separator}>|</span>
                    <span className={classes.date}>{moment(PrismicDate(data.date)).format('DD MMM YYYY')}</span>
                  </div>
                  <div className={classes.socialShare}>
                    <SocialShare/>
                  </div>
                </div>
              </div>
            </header>
            <section className={classes.body}>
              <ArticleBody slices={data.body}/>
            </section>
          </article>
          <Section>
            <Container>
              <Navigator
                previousLink={this.state.newerArticle && (routes.blog + '/' + this.state.newerArticle.uid)}
                previousLabel={'Previous post'}
                nextLink={this.state.olderArticle && (routes.blog + '/' + this.state.olderArticle.uid)}
                nextLabel={'Next post'}
                backLink={routes.blog}
                backLabel={'Back to posts'}
              />
            </Container>
          </Section>
        </div>
      )
    }

    return null;
  }
}


export default pageWithPrismic(withStyles(styles)(ArticlePage), 'blog_page',
  (state) => {
    return {
      articles: state.articles.items
    }
  },
  [fetchArticlesIfNeeded]
);


// WEBPACK FOOTER //
// ./src/pages/ArticlePage.js